/** Hidden chat codeword that forces the real idle-timeout callbacks to run. */
export const IDLE_TIMEOUT_TEST_CODEWORD = "ea.idle.snap.7f2a";

export function isIdleTimeoutTestCodeword(text: string): boolean {
  return text.trim() === IDLE_TIMEOUT_TEST_CODEWORD;
}
